import { API_ROUTES } from 'Utilities/routes';

import axios from '../axios';

export const getServerBuildId = async (): Promise<string | undefined> => (await axios.get(API_ROUTES.BUILD_ID)).data;
